export default __webpack_public_path__ + "static/cover-3cf675aec8fb85ea0d5cc807cf48396f.png";